module.exports = __webpack_public_path__ + "img/login-name.6b4b568b.png";